import React from "react";
import { Card, Button } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import Sheri from "assets/svg/sheri.svg"
import SheriZero from "assets/svg/sherizero.svg"
import { Link, useNavigate } from 'react-router-dom';
import routes, { appRoute } from "shared/constants/routes";
import Arrow from "assets/svg/arrow.svg";
import BackgroundSvg from "assets/svg/shericardsbg.svg";
import SaudiRiyal from "assets/svg/saudi_riyal_symbol.svg";
import { useTranslation } from "contexts/TranslationContext";
import { toast } from "react-toastify";
import env from "shared/constants/env";
// import SilverVoucher from "assets/svg/SilverVoucher.svg";
// import EmeraldVoucher from "assets/svg/EmeraldVoucher.svg";


const VoucherCard = ({ data }) => {
    const navigate = useNavigate();
    const { translate, language } = useTranslation();

    const isArabic = language?.code === "ar" ? true : false;


    const handleClick = async (id) => {
        if (data?.length > 0 && Array.isArray(data) && data.some(item => item.CONTRACT_STATUS !== 'SIGNED')) {
            toast.error(translate("APPLICATION_ALREADY_EXISTS"));
            return;
        }

        try {
            const preAppStatus = await fetch(`${env.API_ENDPOINT}app/pre-app-status?id=${JSON.parse(localStorage.getItem("@@TAMWEEL_USER"))?.IDB_USR_ID}`)

            const response = await preAppStatus.json()

            // console.log('pre', response)

            if (response?.result?.completedSteps.length >= 4 && response?.result?.status === 'COMPLETED') {
                navigate(appRoute(routes.VOUCHERS + `/${id}`));
            } else {
                navigate(appRoute(routes.PRE_APP));
                toast.error("Please complete pre-application steps and try again.");
            }
        } catch (error) {
            console.error("Pre-App Status error:", error);
            toast.error("Something went wrong in checking pre app status. Please try again.");
        }
    };

    return (
        <div style={{
            backgroundImage: `url(${BackgroundSvg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition: "center",
        }}>
            <div className="p-6 flex flex-col-reverse md:flex-row lg:flew-row flex-wrap justify-center gap-8">
                {/* Top Left Card: Detailed */}
                <Card
                    bordered={false}
                    className="rounded-lg shadow-lg bg-transparent"
                    style={{
                        width: '100%',
                        maxWidth: "550px",
                        minHeight: "250px",
                        boxShadow: "none",
                        border: "none",
                        borderRadius: "0",
                        outline: "none",
                        direction: 'ltr'

                    }}
                >

                    <ul className="ml-5 mr-5">
                        {[
                            translate('VOUCHERS.SHERIZERO_PT1'),
                            <>
                                {translate('VOUCHERS.SHERIZERO_PT2')}{""}
                                {/* <Link
                                    // to={appRoute(routes.MERCHANTS)}
                                    // className="text-emerald-700 font-semibold underline ml-1 mr-1"
                                >
                                    {translate('VOUCHERS.EIGHTY_FIVE_MERCHANTS')}
                                </Link> */}
                                <span className="ml-1 mr-1">
                                    {translate('VOUCHERS.EIGHTY_FIVE_MERCHANTS')}
                                </span>
                            </>,
                            <li className="flex items-center" key="riyal-price"> {/* Added flex and items-center to this li */}
                                {isArabic ?
                                    <span className="break-words">
                                        <img src={SaudiRiyal} alt="riyal" className="w-3 h-4 inline-block" /> {translate("VOUCHERS.STARTS_FROM")} {translate('VOUCHERS.FIVE_THOUSAND')}
                                    </span>
                                    :
                                    <span className="break-words">
                                        {translate("VOUCHERS.STARTS_FROM")} <img src={SaudiRiyal} alt="riyal" className="w-3 h-4 inline-block" /> {translate('VOUCHERS.FIVE_THOUSAND')}
                                    </span>}
                            </li>,
                            translate("VOUCHERS.SHERIZERO_PT4"),
                        ].map((text, index) => (
                            <li className="flex mb-4 gap-2" key={index}>
                                <span className="flex-shrink-0">
                                    <img src={Arrow} alt="checkmark" className="w-6 h-6" />
                                </span>
                                <span className="text-sm break-words">{text}</span>
                            </li>
                        ))}
                    </ul>

                    <Button
                        disabled
                        onClick={() => handleClick("1")}
                        // className="mt-4 bg-secondary border-none text-black font-semibold p-5 w-36 rounded-full"
                        className="mt-2 ml-5 mr-5 !bg-blue-950 !text-white border-none font-bold p-5 w-36 rounded-full cursor-not-allowed"
                    >
                        {translate('VOUCHERS.COMING_SOON')}
                    </Button>
                </Card>

                <div
                    className="w-full max-w-[385px] max-h[300px] overflow-hidden"
                >
                    <img src={SheriZero} alt="sheri" className="align-middle" />

                </div>
            </div>

            <div className="p-6 flex flex-wrap justify-center gap-8">
                {/* Bottom Left Card: Minimal */}
                <div
                    className="w-full max-w-[385px] max-h[300px] overflow-hidden"
                >
                    <img src={Sheri} alt="sheri" className="align-middle" />

                </div>

                {/* Bottom Right Card: Detailed */}
                <Card
                    bordered={false}
                    className="rounded-lg shadow-lg bg-transparent"
                    style={{
                        width: '100%',
                        maxWidth: "550px",
                        minHeight: "250px",
                        boxShadow: "none",
                        border: "none",
                        borderRadius: "0",
                        outline: "none",
                        // direction: 'ltr'
                    }}
                >
                    <ul className="ml-5 mr-5">
                        {[
                            translate("VOUCHERS.SHERI_PT1"),
                            <>
                                {translate('VOUCHERS.SHERIZERO_PT2')}{""}
                                <Link
                                    to={appRoute(routes.MERCHANTS)}
                                    className="text-emerald-700 font-semibold underline ml-1 mr-1"
                                >
                                    {translate('VOUCHERS.FOUR_HUNDRED_MERCHANTS')}
                                </Link>
                            </>,
                            <li className="flex items-center" key="riyal-price"> {/* Added flex and items-center to this li */}
                                {isArabic ?
                                    <span className="break-words">
                                        {translate("VOUCHERS.MAX_LIMIT")} {translate('VOUCHERS.FIVE_HUNDRED_THOUSAND')} <img src={SaudiRiyal} alt="riyal" className="w-3 h-4 inline-block" />
                                    </span> :
                                    <span className="break-words">
                                        {translate("VOUCHERS.MAX_LIMIT")} <img src={SaudiRiyal} alt="riyal" className="w-3 h-4 inline-block" /> {translate('VOUCHERS.FIVE_HUNDRED_THOUSAND')}
                                    </span>
                                }
                            </li>,
                            translate('VOUCHERS.SHERI_PT2'),
                        ].map((text, index) => (
                            <li className="flex gap-2 mb-4" key={index}>
                                <span className="flex-shrink-0">
                                    <img src={Arrow} alt="checkmark" className="w-6 h-6" />
                                </span>
                                <span className="text-sm break-words">{text}</span>
                            </li>
                        ))}
                    </ul>

                    <Button
                        onClick={() => handleClick("2")}
                        className="mt-2 ml-5 mr-5 bg-primary border-none text-white font-bold hover:!text-black hover:!bg-secondary p-5 w-36 rounded-full"
                    >
                        {translate("VOUCHERS.APPLY_NOW")}
                    </Button>
                </Card>
            </div>
        </div >
    );
};

export default VoucherCard;

